module.exports = __webpack_public_path__ + "img/live3.2d5fc167.png";